//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../GeometricUtilities/GeometricUtilities.BooleanOperation.js";
import "../no/Section.js";
import "../no/SelectBodyList.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.ModlMotion.js";
import "../no/GeometricUtilities.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/SelectObjectList.js";
let d=[[[1,"BooleanOperation",0,"GeometricUtilities.BooleanOperation",0],[0,"EndShape",1,0],[1,"GuideLines",0,"Section",0],[1,"RunnerBodies",0,"SelectBodyList",0],[1,"SectionOffset",0,"Expression",0],[0,"SectionShape",1,0],[0,"SectionVector",1,"Direction",0],[1,"TransMotion",0,"GeometricUtilities.ModlMotion",0]],[[[],"DeleteRunner",{},0,0],[[],"EditRegisterFile",{},0,0],[[],"EditDataBase",{},0,0],[["sheetData"],"GetDataFromRunnerFeature",{},1,0],[[],"ImportTemplate",{},0,0],[[],"UpdateGuideLoops",{},0,0],[["nType","sectionTypes"],"ReadSectionDataFromDatabase",{},0,0],[["sheetData"],"SetParameterTreeData",{},1,0],[["sectionName"],"ReadSelectedSectionData",{},1,0],[[],"StoreSectionParameters",{},0,0],[[],"EditTemplateExpression",{},0,0],[[],"UpdateTemplatePart",{},0,0],[[],"UpdateGuideOrientation",{},0,0]],[]];
SPLM.Tooling.RunnerBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.RunnerBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.RunnerBuilder.SectionType = Object.freeze({
    "Circular" : "Circular", "Parabolic" : "Parabolic", "Trapezoidal" : "Trapezoidal", "Hexagonal" : "Hexagonal", "SemiCircular" : "SemiCircular"});

SPLM.Tooling.RunnerBuilder.GuideEndType = Object.freeze({
    "Both" : "Both", "StartOnly" : "StartOnly", "EndOnly" : "EndOnly", "None" : "None"});

export default SPLM;